/* This is just the ID and Name of a query. This is all the information we need to display them 
in a list. We can lazily load the rest of the Query when we need it */

import { PrimaryKeyValues } from "table/Table";
import Schema from "./Schema";

export interface LoadableQuery {
    isLoaded : () => boolean;
    getId : () => PrimaryKeyValues | null;
    getName : () => string;
    getKey : () => string;
    // icon?
}

export class SkeletalQuery implements LoadableQuery {
    public id: PrimaryKeyValues;
    public name: string;

    // The schema of the tables this query uses.
    public schema : Schema;

    // Where the query will be loaded from.
    public metadataSource : Schema; 

    constructor(schema: Schema, metadataSource: Schema, id: PrimaryKeyValues, name: string) {
        this.id=id;
        this.name=name;
        this.schema=schema;
        this.metadataSource = metadataSource;
    }
    
    isLoaded = () => {return false}
    getId = () => {return this.id}
    getName = () => {return this.name}
    getKey = () => {return this.schema.name+"/"+String(this.id)}
}

/* There's a better way of doing this. Somehow, use LoadingState, but also allow Id and Name. 
We want a LoadingState instance that also has an id, name and maybe icon. */